import { render, staticRenderFns } from "./mobile-wallets-checkout.vue?vue&type=template&id=d5d073ba"
import script from "./mobile-wallets-checkout.vue?vue&type=script&lang=js"
export * from "./mobile-wallets-checkout.vue?vue&type=script&lang=js"
import style0 from "./mobile-wallets-checkout.vue?vue&type=style&index=0&id=d5d073ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports